import localStore from '../utils/local-storage'
import moment from 'moment';
import { CONSTS } from '../config/Constant';
export const removeWpTags = (content) => {
    if (!content) {
        return ''
    }
    
    let result = content.replace(/<!-- wp:paragraph -->/g, "");
    result = result.replace(/<!-- \/wp:paragraph -->/g, "")
    result = result.replace(/<!-- wp:image (.+) -->$/gm, "")
    result = result.replace(/<!-- \/wp:image -->$/gm, "")
    result = result.replace(/<!-- \/wp:image -->$/gm, "")
    result = result.replace(/<!-- wp:heading -->$/gm, "")
    result = result.replace(/<!-- \/wp:heading -->$/gm, "")
    result = result.replace(/<!-- wp:core-embed\/youtube \/-->$/gm, "")
    return result || "";
}

export const removeUselessChar = (content) => {
    let result = content.replace(/-------/g, "-");
    result = result.replace(/------/g, "-");
    result = result.replace(/-----/g, "-");
    result = result.replace(/----/g, "-");
    result = result.replace(/---/g, "-");
    result = result.replace(/--/g, "-");
    result = result.replace(/--/g, "-");
    result = result.replace(/`/g, "");
    result = result.replace(/‘/g, "'");
    result = result.replace(/’/g, "'");
    return result.replace(/\s+/g, ' ').trim() || "";
}

export const udpateLogPost = action => {
    let time = moment().format('HH:mm DD/MM/YYYY');
    let ip = localStore.get("publicIp");
    let name = localStore.get("_user");
    return `${time} - ${ip} - ${name.username} - ${action},`;
}

export const updateLogPostGroup = (action, logs )=> {
    let time = moment().format('HH:mm DD/MM/YYYY');
    let ip = localStore.get("publicIp");
    let name = localStore.get("_user");
    let logStringArr = [];
    console.log(Object.entries(logs));
    for (const [key, data] of Object.entries(logs)) {
        console.log(data);
        if(data.value != "" && data.value != null){
            logStringArr.push(`${data.label}: ${data.value}`);
        }
    }
    return `${time} - ${ip} - ${name.username} - ${action} [${logStringArr.join(' | ')}],`;
}

export const remove_non_ascii = (str) => {
    if ((str === null) || (str === '')) {
        return false;
    } else {
        str = str.toString();
    }

    return str.replace(/[^\x20-\x7E]/g, '');
}

export const getYear = (date) => {
    if(!date) date = new Date();
    return new Date(date).getFullYear();
}

export const getMonth = (date) => {
    if(!date) date = new Date();
    return String(new Date(date).getMonth() + 1).padStart(2, '0');
}

export const getDate = (date) => {
    if(!date) date = new Date();
    return String(new Date(date).getDate()).padStart(2, '0');
}